import { EncoderState } from 'src/contracts/encoderState';
import { useGrouperStore } from 'stores/grouper-store';
import { useLayoutStore } from 'stores/layout-store';

export function getEncoderState(): EncoderState {
  return {
    grouperState: useGrouperStore().getGrouperState(),
    layoutState: useLayoutStore().getLayoutState()
  }
}

export function setEncoderState(state: EncoderState): void {

  if (!state) {
    return;
  }

  useGrouperStore().setGrouperState(state.grouperState);
  useLayoutStore().setLayoutState(state.layoutState);
}